import { useState } from "react";
import PoweredByFlexiFunnels from "./PoweredByFlexiFunnels";
import RichText from "./RichText";

/**
 * Footer with Privacy Policy / Terms links (bottom-right).
 * Clicking a link opens the community's policy content in a modal.
 *
 * `showBranding` (driven by the community owner's branding add-on, via the API)
 * toggles the "Powered by FlexiFunnels" mark.
 */
function PolicyFooter({ policies, primary = "#0274F7", showBranding = false }) {
  const [open, setOpen] = useState(null); // "privacy" | "terms" | null

  const hasPrivacy = !!policies?.privacy;
  const hasTerms = !!policies?.terms;

  return (
    <footer className="border-t bg-white mt-auto">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:block items-center gap-2">
        {showBranding && <PoweredByFlexiFunnels className="mx-auto" />}
        <div className="flex items-center gap-3 text-sm text-gray-500 sm:absolute sm:right-6 sm:top-1/2 sm:-translate-y-1/2">
          {hasPrivacy && (
            <button onClick={() => setOpen("privacy")} className="hover:text-gray-800 transition">
              Privacy Policy
            </button>
          )}
          {hasPrivacy && hasTerms && <span className="text-gray-300">·</span>}
          {hasTerms && (
            <button onClick={() => setOpen("terms")} className="hover:text-gray-800 transition">
              Terms
            </button>
          )}
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center bg-gray-900/60 backdrop-blur-sm p-0 sm:p-4"
          onClick={() => setOpen(null)}
        >
          <div
            className="bg-white w-full sm:max-w-2xl rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[90vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between px-6 py-4 border-b">
              <h3 className="font-semibold text-gray-900">
                {open === "privacy" ? "Privacy Policy" : "Terms"}
              </h3>
              <button
                onClick={() => setOpen(null)}
                aria-label="Close"
                className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <RichText
              html={open === "privacy" ? policies.privacy : policies.terms}
              className="px-6 py-5 overflow-y-auto text-sm text-gray-600 leading-relaxed"
            />
            <div className="px-6 py-3 border-t text-right">
              <button
                onClick={() => setOpen(null)}
                style={{ backgroundColor: primary }}
                className="text-white text-sm font-semibold px-5 py-2 rounded-lg hover:opacity-90"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

export default PolicyFooter;
